import request from '@/utils/request'

export const getMyPayslips = params => request.get('/me/payslips', { params })

export const getMyPayslip = payrollRunId => request.get(`/me/payslips/${payrollRunId}`)
